export default "__VITE_ASSET__CFOsCQcM__"